import { mapActions } from "vuex";
import moment from "moment";
import URI from "urijs";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons/faTrashAlt";

export default {
  props: ["notification", "theme"],
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      moreDetailsVisible: false,
      linkTarget: this.$_notifications_config.openLinksInNewWindow
        ? "_blank"
        : false,
      faTrashAlt,
    };
  },
  computed: {
    timer() {
      return moment(this.notification.createdAt).fromNow();
    },
  },
  methods: {
    ...mapActions(["readNotification"]),
    formatUrl(initialUrl) {
      const regex = new RegExp(/^(http|https):/, "i");
      const url = regex.test(initialUrl)
        ? initialUrl
        : this.$_notifications_config.jiminnyHost() + initialUrl;

      return URI(url).addQuery("nId", this.notification.id).toString();
    },
    photoUrl(url) {
      return url || this.$_notifications_config.defaultAvatarUrl;
    },
    toggleMoreDetails() {
      this.moreDetailsVisible = !this.moreDetailsVisible;
    },
  },
};



// WEBPACK FOOTER //
// ./~/vue-components/notifications/components/notifications/notification.js